<template>
    <div class="container-fluid mt-2">
        <div class="card border-secondary mb-3" >
            <div class="card-header bg-light">
                <div class="row">
                    <div class="col-2 text-start">
                        <button type="button" class="btn btn-success btn-sm" @click="backPage()">ย้อนกลับ</button>
                    </div>
                    <div class="col d-flex justify-content-end"> <span class="rounded-pill text-white bg-danger px-3 pt-1">แก้ไขใบสั่งตรวจ</span> </div>
                    <!-- <div class="col"><h5 class="rounded-pill text-white bg-danger pt-2">แก้ไขใบสั่งตรวจ</h5> </div> -->
                </div>
            </div>
            <div class="card-body" >
                <div class="row pt-2 text-start mb-2">
                    <form id="fmRO" @submit.prevent="" >
                        <div class="row mb-1">
                            <div class="col-sm-12 col-xl-5 text-start">
                                <input type="text" hidden class="form-control" id="CorpID" placeholder="" name="CorpID" v-model="globalCorpID" >
                                <input type="text" hidden class="form-control" placeholder="" name="action" v-model="action" >
                                <input type="text" hidden class="form-control" placeholder="" name="id" >
                                <div class="input-group input-group-sm mb-3">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">สาขา* :</span>
                                    </div>
                                    <select class="form-select form-select-sm" ref="BranchID" id="BranchID" name="BranchID" v-model="curRecordHd.BranchID" disabled>
                                        <option disabled value="">Please select one</option>
                                        <option v-for="item in dataBranchlists" :key="item.BranchID" :value="item.BranchID">{{ item.BranchName }}</option>
                                    </select>
                                </div>
                                <div class="input-group input-group-sm mb-1">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">เลขที่* :</span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm bg-light" ref="RONo" id="RONo" name="RONo" v-model="curRecordHd.RONo" readonly>
                                    <!-- <button type="button" class="btn btn-info mx-1" @click="autoRONO()" style="width:100px;">Auto</button> -->
                                </div>
                                <div class="input-group input-group-sm mb-1">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">วันที่* :</span>
                                    </div>
                                    <v-date-picker mode="date" v-model="curRecordHd.DocDate" :masks="masks">
                                        <template v-slot="{ inputValue, inputEvents }">
                                            <input name="DocDate" ref="DocDate"
                                            class="bg-white border px-2 py-1 rounded"
                                            :value="inputValue"
                                            v-on="inputEvents"
                                            />
                                        </template>
                                    </v-date-picker>
                                </div>
                                <!-- คนไข้ : ชื่อ / นามสกุล -->
                                <div class="input-group input-group-sm mb-1">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">ชื่อคนไข้ * :</span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" style="background-color:PapayaWhip;" ref="PatName" name="PatName" v-model="curRecordHd.PatName" disabled>
                                    <button type="button" id="btnFindPat" class="btn btn-secondary ms-1" data-bs-toggle="modal" data-bs-target="#findPatientModal" >ค้นหา..</button>
                                    <button type="button" id="btnNewPat"  class="btn btn-info ms-1" data-bs-toggle="modal" data-bs-target="#addPatientModal" @click="btnAddPatientClick()">เพิ่ม..</button>
                                </div>
                                <div class="input-group input-group-sm mb-1">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">นามสกุล * :</span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" style="background-color:PapayaWhip;" ref="PatLName" name="PatLName" v-model="curRecordHd.PatLName" disabled>
                                </div>
                                <!-- ชีพจร/ความดันโลหิต -->
                                <div class="row container m-1 mb-0 pt-1">
                                  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-8 col-xxl-6 text-start px-0">
                                      <div class="input-group input-group-sm">
                                        <span class="input-group-text" style="width:140px;">ความดันโลหิต (mmHg)</span>
                                        <input type="number" class="form-control form-control-sm me-1" name="BP_1" v-model="curRecordHd.BP_1">
                                        <span class="mt-1 me-1">/</span>
                                        <input type="number" class="form-control form-control-sm me-1" name="BP_2" v-model="curRecordHd.BP_2">
                                      </div>
                                  </div>
                                  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-8 col-xxl-6 text-start">
                                      <div class="input-group input-group-sm">
                                        <span class="input-group-text" style="width:120px;">ชีพจร(ครั้งต่อนาที)</span>
                                        <input type="number" class="form-control form-control-sm me-2" ref="Pulse" name="Pulse" v-model="curRecordHd.Pulse">
                                      </div>
                                  </div>
                                </div>
                                <!-- นน/ส่วนสูง -->
                                <div class="row container m-1 pb-1">
                                  <div class="col-sm-12 col-md-12 col-lg-6 col-xl-3 text-start px-0" >
                                      <div class="input-group input-group-sm">
                                        <span class="input-group-text" style="width:100px;">น้ำหนัก (kg.)</span>
                                        <input type="number" class="form-control form-control-sm me-2" ref="IDNo" name="Weight" v-model="curRecordHd.Weight" style="width:60px;" step="0.1">
                                      </div>
                                  </div>
                                  <div class="col-sm-12 col-md-12 col-lg-6 col-xl-3 text-start px-0">
                                      <div class="input-group input-group-sm">
                                        <span class="input-group-text" style="width:100px;">ส่วนสูง (cm.)</span>
                                        <input type="number" class="form-control form-control-sm me-2" name="Height" v-model="curRecordHd.Height" step="0.1">
                                      </div>
                                  </div>
                                  <div class="col-sm-12 col-md-12 col-lg-6 col-xl-3 text-start px-0">
                                      <div class="input-group input-group-sm" title="อุณหภูมิร่างกาย">
                                        <span class="input-group-text" style="width:100px;">อุณหภูมิ &#8451;</span>
                                        <input type="number" class="form-control form-control-sm me-2" ref="BodyTemp" name="BodyTemp" v-model="curRecordHd.BodyTemp" step="0.1">
                                      </div>
                                  </div>
                                  <div class="col-sm-12 col-md-12 col-lg-6 col-xl-3 text-start px-0">
                                      <div class="input-group input-group-sm" title="ค่าความอิ่มตัวของออกซิเจนในเลือด(SpO2)">
                                        <span class="input-group-text" style="width:100px;">SpO2 (%)</span>
                                        <input type="number" class="form-control form-control-sm me-2" ref="SpO2" name="SpO2" v-model="curRecordHd.SpO2" step="0.1">
                                      </div>
                                  </div>
                                </div>
                                <!-- Specimen สิ่งส่งตรวจ -->
                                <div class="input-group input-group-sm mb-2" title="สิ่งส่งตรวจ">
                                    <div class="input-group-prepend">
                                      <label for="Specimen" class="input-group-text" style="width:120px;">Specimens :</label>
                                      <!-- <span class="input-group-text" style="width:120px;">หมายเหตุ :</span> -->
                                    </div>
                                    <input type="text" class="form-control form-control-sm me-1" ref="Specimen" name="Specimen" v-model="curRecordHd.Specimen">
                                    <button class="btn btn-sm btn-outline-warning px-3" id="" title="ลบ specimen ออกบางรายการ"
                                      data-bs-toggle="modal" data-bs-target="#removeSpecimenHdModal" @click="btnRemoveSpecimenHdClicked()"><b>-</b></button>
                                    <button class="btn btn-sm btn-outline-primary px-3" id="" title="เพิ่ม specimen"
                                      data-bs-toggle="modal" data-bs-target="#addSpecimenHdModal" @click="btnAddSpecimenHdClicked()"><b>+</b></button>
                                    <button class="btn btn-sm btn-outline-danger px-3" id="" title="ลบทั้งหมด" @click="clearSpecimenHdAll()">x</button>
                                </div>
                                <!-- คลินิก -->
                                <div class="input-group input-group-sm mb-1">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">คลินิก* :</span>
                                    </div>
                                    <select class="form-select form-select-sm" ref="ReqClinicID" name="ReqClinicID" v-model="curRecordHd.ReqClinicID" @change="getClinicUnitPriceNo($event)">
                                        <option disabled value="">Please select one</option>
                                        <option v-for="item in dataCliniclists" :key="item.ReqClinicID" :value="item.ReqClinicID">{{ item.ReqClinicName }}</option>
                                    </select>
                                    <!-- <input type="text" class="form-control form-control-sm" name="reqclinic" v-model="curRecordHd.ReqClinicName"> -->
                                </div>
                                <div class="input-group input-group-sm mb-1">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">ราคาขายที่ * :</span>
                                    </div>
                                    <select class="form-select" ref="UnitPriceNo" name="UnitPriceNo" v-model="curRecordHd.UnitPriceNo"
                                      @change="calculateAmountMaster()"
                                      style="background-color:PapayaWhip;"
                                      title="ระบุราคาขายสำหรับคลินิกนี้ (จากราคาขายทั้งหมด 5 ราคา)">
                                      <option class="bg-white" value="1">ราคาที่ 1</option>
                                      <option class="bg-white" value="2">ราคาที่ 2</option>
                                      <option class="bg-white" value="3">ราคาที่ 3</option>
                                      <option class="bg-white" value="4">ราคาที่ 4</option>
                                      <option class="bg-white" value="5">ราคาที่ 5</option>
                                    </select>
                                </div>

                                <div class="input-group input-group-sm mb-1">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">HN No. :</span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" ref="HNNo" name="HNNo" v-model="curRecordHd.HNNo">
                                </div>
                                <div class="input-group input-group-sm mb-1">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">ผู้บันทึก * :</span>
                                    </div>
                                    <select class="form-select form-select-sm" ref="OfficerID1" name="OfficerID1" v-model="curRecordHd.OfficerID1" disabled>
                                        <option disabled value="">Please select one</option>
                                        <option v-for="item in dataOfficerlists" :key="item.UserID" :value="item.UserID">{{ item.OfficialName }} ({{item.Username}})</option>
                                    </select>
                                    <!-- <input type="text" class="form-control form-control-sm" name="officer1" v-model="curRecordHd.OfficerName1"> -->
                                </div>
                                <div class="input-group input-group-sm mb-2">
                                    <div class="input-group-prepend">
                                      <label for="Remark" class="input-group-text" style="width:120px;">หมายเหตุ :</label>
                                      <!-- <span class="input-group-text" style="width:120px;">หมายเหตุ :</span> -->
                                    </div>
                                    <textarea id="Remark" ref="taRemark" name="Remark" rows="2" cols="60" class="px-1" style="resize: both;" v-model="curRecordHd.Remark"></textarea>
                                    <button class="btn btn-sm btn-outline-primary px-3" id="" title="เลือกหมายเหตุจากรายการที่เตรียมไว้"
                                      data-bs-toggle="modal" data-bs-target="#addRemarkModal" @click="btnAddRemarkClicked()"><b>+</b></button>
                                    <!-- <input type="text" class="form-control form-control-sm" ref="Remark" name="Remark" v-model="curRecordHd.Remark"> -->
                                </div>
                                <br>
                                <div class="row mb-2">
                                    <div class="col">
                                      <button type="button" class="btn btn-primary" style="width:100%;" @click="saveDataMasterDetail">บันทึกเอกสาร</button>
                                      <hr>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-xl-7">
                                <!-- ----------------------------------------- -->
                                <!-- 1.ตารางชุดตรวจ ที่สั่งตรวจ -->
                                <!-- ----------------------------------------- -->
                                <div class="row mb-1">
                                    <!-- ปุ่ม สั่งตรวจเลือกจากตาราง -->
                                    <button type="button" class="btn btn-success me-2 " v-show="curRecordHd.Paid==0"
                                      data-bs-toggle="modal" data-bs-target="#addTestsuitModal"
                                      style="width:200px;"><i class="fa fa-bars me-1" aria-hidden="true"></i> สั่งตรวจเลือกจากตาราง</button>
                                    <!-- ปุ่ม เลือกตามห้อง -->
                                    <button type="button" class="btn btn-success me-2" v-show="curRecordHd.Paid==0"
                                      data-bs-toggle="modal" data-bs-target="#addTestsuit_CheckboxModal"
                                      @click="addTestsuit_Checkbox_Clicked()"
                                      style="width:200px;"><i class="fa fa-check-square me-1" aria-hidden="true"></i> เลือกตามห้อง</button>
                                    <!-- ปุ่ม เลือกจากประวัติเดิม -->
                                    <button type="button" class="btn btn-success me-2" data-bs-toggle="modal" data-bs-target="#addTestsuit_HistoryModal"
                                    @click="addTestsuit_History_Clicked()" v-if="condHistPatID > 0"
                                    style="width:200px;"><i class="fa fa-history me-1" aria-hidden="true"></i> เลือกจากประวัติเดิม</button>
                                </div>
                                <div class="row bg-light mb-1">
                                    <table id="myRODetailTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                                        <thead class="text-white" style="background:black">
                                        <tr>
                                            <!-- <th >รหัสคลินิก</th> -->
                                            <th class="text-center">หน้าใหม่</th>
                                            <th>รหัสชุดตรวจ</th>
                                            <th>ชุดตรวจ</th>
                                            <th colspan="2">Specimen</th>
                                            <th>ราคา</th>
                                            <th>คำสั่ง</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(item, index) in dataDtllists" :key="item.TestID">
                                            <td class="text-center" width="120px;" title="ระบุให้ขึ้นหน้าใหม่">
                                              <select class="form-select form-select-sm" name="" v-model="dataDtllists[index].NewPage" >
                                                <option :value="0" title="พิมพ์หน้าเดียวกัน"></option>
                                                <option :value="1" title="ขึ้นหน้าใหม่">New Page</option>
                                              </select>
                                            </td>
                                            <td class="text-start">{{ item.TestCode }}</td>
                                            <td class="text-start">{{ item.TestName }}</td>
                                            <td class="text-start">{{ item.Specimen }}</td>
                                            <td class="text-end">
                                              <button class="btn btn-sm btn-outline-warning py-0 ms-1" id="Remove" title="ลบ specimen ออกบางรายการ"
                                                data-bs-toggle="modal" data-bs-target="#removeSpecimenModal" @click="btnRemoveSpecimenClicked(index)"><b>-</b></button>
                                              <button class="btn btn-sm btn-outline-primary py-0 mx-1" id="Remove" title="เพิ่ม specimen"
                                                data-bs-toggle="modal" data-bs-target="#addSpecimenModal"
                                                @click="btnAddSpecimenClicked(index)"><b>+</b></button>
                                              <button class="btn btn-sm btn-outline-danger py-0" id="Remove" title="ลบทั้งหมด"
                                                @click="clearSpecimenAll(index)">x</button>
                                            </td>
                                            <td class="text-end" :title=' "ราคาขาย 1-5 : "+item.UnitPrice +" / "+item.UnitPrice2+" / "+item.UnitPrice3 +" / "+item.UnitPrice4+" / "+item.UnitPrice5'>
                                              <span v-if="curRecordHd.UnitPriceNo == 1">{{ numeralFormat(item.UnitPrice, '0,0[.]00') }}</span>
                                              <span v-if="curRecordHd.UnitPriceNo == 2">{{ numeralFormat(item.UnitPrice2, '0,0[.]00') }}</span>
                                              <span v-if="curRecordHd.UnitPriceNo == 3">{{ numeralFormat(item.UnitPrice3, '0,0[.]00') }}</span>
                                              <span v-if="curRecordHd.UnitPriceNo == 4">{{ numeralFormat(item.UnitPrice4, '0,0[.]00') }}</span>
                                              <span v-if="curRecordHd.UnitPriceNo == 5">{{ numeralFormat(item.UnitPrice5, '0,0[.]00') }}</span>
                                            </td>
                                            <td  >
                                                <button class="btn btn-danger btn-sm " id="Delete"
                                                  v-show="curRecordHd.Paid==0"
                                                  @click="delDtlTable(index)">Del</button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <hr>
                                <!-- ----------------------------------------- -->
                                <!-- 2.ตารางแพคเกจ ที่สั่งตรวจ -->
                                <!-- ----------------------------------------- -->
                                <div class="row mb-1">
                                    <button type="button" class="btn btn-warning me-2"
                                      v-show="curRecordHd.Paid==0"
                                      data-bs-toggle="modal" data-bs-target="#addProPackageModal"
                                      style="width:250px;">เพิ่มแพคเกจสั่งตรวจ</button>
                                </div>
                                <div class="row bg-light mb-1">
                                    <table id="myPropackDetailTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                                        <thead class="text-dark" style="background:GoldenRod">
                                        <tr>
                                            <!-- <th >รหัสคลินิก</th> -->
                                            <th class="text-center"  style="width:80px;">หน้าใหม่</th>
                                            <th style="width:100px;">รหัสแพคเกจ</th>
                                            <th style="width:300px;">ชื่อชุดแพคเกจ</th>
                                            <th style="width:100px;">ราคา</th>
                                            <th style="width:60px;">คำสั่ง</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(item, index) in dataDtllistsPropack" :key="item.PropackID">
                                            <td class="text-center" width="120px;" title="ระบุให้ขึ้นหน้าใหม่">
                                              <select class="form-select form-select-sm" name="" v-model="dataDtllistsPropack[index].NewPage" >
                                                <option :value="0" title="พิมพ์หน้าเดียวกัน"></option>
                                                <option :value="1" title="ขึ้นหน้าใหม่">New Page</option>
                                              </select>
                                            </td>

                                            <td class="text-start">{{ item.PropackCode }}</td>
                                            <td class="text-start">{{ item.PropackName }}</td>
                                            <td class="text-start">{{ numeralFormat(item.UnitPrice, '0,0[.]00') }}</td>
                                            <td  >
                                              <button class="btn btn-danger btn-sm " id="Delete"
                                                v-show="curRecordHd.Paid==0"
                                                @click="delDtlTablePropack(index)">Del</button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <!-- รวมเป็นเงิน -->
                                <div class="row mb-1">
                                    <div class="col-6">
                                        <div class="input-group input-group-sm  mt-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" style="width:120px;">การชำระเงิน :</span>
                                            </div>
                                            <div class="form-check form-check-inline py-1 ms-2">
                                                <input class="form-check-input" type="radio" name="PayType" id="rdPayType1" value="0"
                                                  :disabled="curRecordHd.Paid==1"
                                                  v-model="curRecordHd.PayType">
                                                <label class="form-check-label" for="rdPayType1">เงินสด</label>
                                            </div>
                                            <div class="form-check form-check-inline py-1">
                                                <input class="form-check-input" type="radio" name="PayType" id="rdPayType2" value="1"
                                                  :disabled="curRecordHd.Paid==1"
                                                  v-model="curRecordHd.PayType">
                                                <label class="form-check-label" for="rdPayType2">เครดิต</label>
                                            </div>
                                        </div>
                                        <div class="container mt-3" v-show="curRecordHd.Paid==1">
                                          <div class="alert alert-danger" role="alert">
                                            ชำระเงินแล้ว
                                          </div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="input-group">
                                            <span class="input-group-text" style="width:120px;">รวมเป็นเงิน</span>
                                            <input type="number" class="form-control" v-model="curRecordHd.TotalAmt" disabled>
                                        </div>
                                        <div class="input-group">
                                            <span class="input-group-text" style="width:120px;">ส่วนลด</span>
                                            <input type="number" class="form-control" v-model="curRecordHd.DiscRate" min="0"
                                              :disabled="curRecordHd.Paid==1"
                                              @change="calculateAmountMaster()">
                                            <input type="number" class="form-control" v-model="curRecordHd.DiscAmt"  min="0" :max="curRecordHd.TotalAmt"
                                              :disabled="curRecordHd.Paid==1"
                                              @change="calculateAmountMaster()">
                                        </div>
                                        <div class="input-group">
                                            <span class="input-group-text" style="width:120px;">VAT</span>
                                            <input type="number" class="form-control" v-model="curRecordHd.VatRate" min="0" max="15"
                                              :disabled="curRecordHd.Paid==1"
                                              @change="calculateAmountMaster()">
                                            <input type="number" class="form-control" v-model="curRecordHd.VatAmt" disabled>
                                        </div>
                                        <div class="input-group">
                                            <span class="input-group-text" style="width:120px;">สุทธิ</span>
                                            <input type="number" class="form-control" v-model="curRecordHd.NetAmt" disabled>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </form>
                    <br>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal แสดงหน้าต่างค้นหารายชื่อคนไข้ -->
    <div id="findPatientModal" class="modal" tabindex="-1">
        <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title">ค้นหาคนไข้จากทะเบียนประวัติ</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="row bg-light mb-2">
                  <div class="col-2"></div>
                  <div class="col">
                    <div class="input-group input-group-sm mb-1" title="ป้อนคำเพื่อค้นหาจากชื่อ นามสกุลและเลขบัตรประชาชน / Passport No.">
                        <div class="input-group-prepend">
                        <span class="input-group-text fs-3" style="width:140px;">คำค้นหา :</span>
                        </div>
                        <input type="text" class="form-control form-control-sm fs-3" placeholder="ป้อนคำค้นหา"
                          name="findTextPatient" v-model="findTextPatient" v-on:keyup.enter="findPatients()">
                        <button class="btn bg-transparent" style="margin-left: -40px; z-index: 100;" @click="findTextPatient=''">
                            <i class="fa fa-times"></i>
                        </button>
                        <button type="button" class="btn btn-info fs-3 mx-1" style="width:100px;" @click="findPatients()">ค้นหา</button>
                    </div>
                  </div>
                  <div class="col-2"></div>
                </div>
                <table id="myFindPatientTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                    <thead class="text-white" style="background:Navy">
                    <tr>
                        <th>คำนำหน้า</th>
                        <th>ชื่อ</th>
                        <th>นามสกุล</th>
                        <th>เลขบัตรปชช.</th>
                        <th>จังหวัด</th>
                        <th>ประเทศ / พาสปอร์ต</th>
                        <th>คำสั่ง</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in dataPatientFindlists" :key="item.PatID">
                        <td class="text-start">{{ item.PrefixName }}</td>
                        <td class="text-start">{{ item.PatName }}</td>
                        <td class="text-start">{{ item.PatLName }}</td>
                        <td class="text-start">{{ item.IDNo }}</td>
                        <td class="text-start">{{ item.Province }}</td>
                        <td class="text-start">{{ item.Country }} / {{ item.PassportNo }}</td>
                        <td  >
                            <button type="button" class="btn btn-info btn-sm" data-bs-dismiss="modal"
                              id="add" @click="selectPatient(item)">เลือก</button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="modal-footer">
              <div class="container">
                <button type="button" class="btn btn-info pull-left" data-bs-dismiss="modal"
                  @click="openAddPatModal()">เพิ่มรายชื่อคนไข้..</button>
                <button type="button" class="btn btn-secondary pull-right" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
        </div>
        </div>
    </div>

    <!-- Modal แสดงชุดตรวจให้เลือกแบบ History (11-Apr-2567) แสดงชุดเทสตรวจจากประวัติเก่า -->
    <div id="addTestsuit_HistoryModal" class="modal" tabindex="-1" style="font-size:80%;">
        <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title">แสดงประวัติรายการสั่งตรวจ : เลือกจากประวัติเดิม </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <!-- Checkbox Testsuits : แยกตามห้องตรวจ -->
                <div class="row text-start mt-2 p-2">
                  <div class="col-5 page-scroll">
                    <table id="myHistPatROTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                        <thead class="text-white" style="background:Navy">
                        <tr>
                            <th style="width:40px;" class="text-center">วันที่ใบสั่งตรวจ</th>
                            <th style="width:10px;"></th>
                            <th style="width:40px;" class="text-center">เลขที่</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in dataHistPatROlists" :key="item.ROID" @click="myHistPatROTableChanged($event, item)">
                            <td class="text-center">{{ item.DocDate }}</td>
                            <td class="text-center">{{ arrDocStatus[item.Status] }}</td>
                            <td class="text-center">{{ item.RONo }}</td>
                        </tr>
                        </tbody>
                    </table>
                  </div>
                  <div class="col page-scroll">
                    <table id="myAddHistoryTestsuitTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                        <thead class="text-white" style="background:Navy">
                        <tr>
                            <th style="width:40px;">รหัสชุดตรวจ</th>
                            <th class="text-center" style="width:5px;" title="เป็นชุดตรวจที่สร้าง(Clone)มาจากเทส">C</th>
                            <th style="width:250px;">ชื่อชุดตรวจ</th>
                            <th style="width:100px;">ห้องตรวจ</th>
                            <th style="width:40px;">คำสั่ง</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in dataHistPatRODtllists" :key="item.TestID">
                            <td class="text-start">{{ item.TestCode }}</td>
                            <td class="text-center"> <span v-if="item.FromItemTest==1"><i class="fa fa-clone text-warning"></i></span></td>
                            <td class="text-start" :title="'ประกอบด้วย ' + item.count_items + ' items'">
                              <b>{{ item.TestName }}</b>
                              <span class="badge bg-secondary float-end ms-2" v-if="item.count_items>1">{{item.count_items}}</span>
                            </td>
                            <td class="text-start text-primary">{{ item.room_name }}</td>
                            <td  >
                                <button type="button" class="btn btn-info btn-sm py-0" id="add" @click="addDtlTable(item)">Add</button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                  </div>
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
        </div>
    </div>
    <!-- Modal แสดงชุดตรวจให้เลือกแบบ CheckBox (02-Sep-2566) -->
    <div id="addTestsuit_CheckboxModal" class="modal" tabindex="-1" style="font-size:80%;">
        <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title">เพิ่มรายการสั่งตรวจ (ชุดตรวจ)</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <!-- Radio buttons : แสดงชื่อห้อง -->
                <div class="container-fluid p-0 text-start">
                  <input type="radio" class="btn-check me-2" name="optionsAll" id="optionsAll" value="0" v-model="rdRoomTypeID" @change="roomType_Changed(null)">
                  <label class="btn btn-outline-success py-1 me-3" for="optionsAll">ทุกห้อง</label>
                  <template v-for="item in dataRoomtypelists" :key="item.id">
                    <input type="radio" class="btn-check" :name="'options' + item.id" :id="'options' + item.id" :value="item.id" v-model="rdRoomTypeID" @change="roomType_Changed(item)">
                    <!-- แสดงปุ่มห้องตรวจสีเขียว ถ้าเป็นห้องตรวจปกติ -->
                    <label class="btn btn-outline-success py-1 me-1 mb-1" :for="'options' + item.id"
                      v-if="parseInt(item.RoomType)==0">{{item.room_name}}</label>
                    <!-- แสดงปุ่มห้องตรวจสีเหลือง ถ้าเป็นห้องตรวจเสมือน(มาจากแพคเกจ) -->
                    <label class="btn btn-outline-warning py-1 me-1 mb-1" :for="'options' + item.id"
                      v-else>{{item.room_name}}</label>
                  </template>
                </div>
                <!-- Checkbox Testsuits : แยกตามห้องตรวจ -->
                <div class="row text-start mt-2 p-2 page-scroll">
                  <div class="col">
                    <div class="form-check form-check-inline" v-for="item in dataTS_chkboxlist" :key="item.TestID" style="width:190px;">
                      <input type="checkbox" class="btn-check float-start" :title="item.TestName" v-model="TS_selectedlist"
                        :name="'chkTS' + item.TestID" :id="'chkTS' + item.TestID" :value="item" autocomplete="off">
                      <label class="btn btn-outline-primary text-start" :for="'chkTS' + item.TestID" :title="item.TestName" style="width:100%;">
                        <input type="checkbox" class="me-2 cursor: pointer;" :title="item.TestName" v-model="TS_selectedlist"
                          :name="'chkTS' + item.TestID" :id="'chkTS' + item.TestID" :value="item"
                          ref="theCheckbox"/>
                        <span v-if="item.count_items>1" class=""> <b>{{item.TestCode}}</b></span>
                        <span v-else>{{item.TestCode}}</span>
                        <span class="badge bg-secondary float-end ms-2" v-if="item.count_items>1">{{item.count_items}}</span>
                      </label>
                    </div>
                  </div>
                </div>
            </div>

            <div class="modal-footer">
                <p class="me-4">{{TS_selectedlist.length}} รายการ</p>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="addDtlTable_from_TS_selectedlist(TS_selectedlist)">สั่งตรวจ</button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
        </div>
    </div>
    <!-- Modal แสดงชุดตรวจให้เลือกแบบตาราง -->
    <div id="addTestsuitModal" class="modal" tabindex="-1">
        <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title">เพิ่มรายการสั่งตรวจ (ชุดตรวจ)</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <table id="myAddTestsuitTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                    <thead class="text-white" style="background:Navy">
                    <tr>
                        <th style="width:40px;">รหัสชุดตรวจ</th>
                        <th class="text-center" style="width:5px;" title="เป็นชุดตรวจที่สร้าง(Clone)มาจากเทส">C</th>
                        <th style="width:250px;">ชื่อชุดตรวจ</th>
                        <th style="width:100px;">Specimen</th>
                        <th style="width:100px;">ห้องตรวจ</th>
                        <th style="width:120px;">ราคาขายที่ 1-5</th>
                        <th style="width:40px;">คำสั่ง</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in dataTestSuitlists" :key="item.TestID">
                        <td class="text-start">{{ item.TestCode }}</td>
                        <td class="text-center"> <span v-if="item.FromItemTest==1"><i class="fa fa-clone text-warning"></i></span></td>
                        <td class="text-start" :title="'ประกอบด้วย ' + item.count_items + ' items'"><b>{{ item.TestName }}</b></td>
                        <td class="text-start">{{ item.Specimen }}</td>
                        <td class="text-start text-primary">{{ item.room_name }}</td>
                        <td class="text-end">
                          {{ numeralFormat(item.UnitPrice, '0,0[.]00') }} /
                          {{ numeralFormat(item.UnitPrice2, '0,0[.]00') }} /
                          {{ numeralFormat(item.UnitPrice3, '0,0[.]00') }} /
                          {{ numeralFormat(item.UnitPrice4, '0,0[.]00') }} /
                          {{ numeralFormat(item.UnitPrice5, '0,0[.]00') }}
                        </td>
                        <td  >
                            <button type="button" class="btn btn-info btn-sm" id="add" @click="addDtlTable(item)">Add</button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
        </div>
    </div>
    <!-- Modal แสดงแพคเกจชุดตรวจให้เลือก -->
    <div id="addProPackageModal" class="modal" tabindex="-1">
        <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title">เพิ่มแพคเกจสั่งตรวจ</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <table id="myAddPropackTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                    <thead class="text-white" style="background:Navy">
                    <tr>
                        <th style="width:100px;">รหัสแพคเกจ</th>
                        <th style="width:250px;">ชื่อชุดแพคเกจ</th>
                        <th style="width:40px;">ราคาขาย</th>
                        <th style="width:40px;">คำสั่ง</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in dataPropacklists" :key="item.PropackID">
                        <td class="text-start">{{ item.PropackCode }}</td>
                        <td class="text-start" :title="'ประกอบด้วย ' + item.count_items + ' items'">
                          <b>{{ item.PropackName }}</b>
                          <span class="badge bg-secondary float-end me-4">{{item.count_items}}</span>
                        </td>
                        <td class="text-end">{{ numeralFormat(item.UnitPrice, '0,0[.]00') }}</td>
                        <td  >
                            <button type="button" class="btn btn-info btn-sm py-0" id="add" @click="addDtlTablePropack(item)">Add</button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
        </div>
    </div>

    <!-- Modal หน้าจอเพิ่มรายชื่อคนไข้ใหม่ -->
    <div id="addPatientModal" class="modal" tabindex="-1">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Patient : ป้อนรายชื่อคนไข้</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form id="fmPatient" ref="fmPatient" @submit.prevent="" >
                <input type="text" hidden class="form-control" id="CorpIDpat" ref="CorpIDpat" placeholder="" name="CorpID" v-model="globalCorpID" >
                <input type="text" hidden class="form-control" id="action" placeholder="" name="action" v-model="action" >
                <input type="text" hidden class="form-control" placeholder="" name="id">
                <div class="row mb-1">
                    <div class="col-8 text-start">
                        <div class="input-group input-group-sm" title="ใช้เลขบัตรประชาชนได้หรือกดปุ่ม Auto เพื่อสร้างเลขประจำตัวคนไข้">
                          <span class="input-group-text" style="width:180px;">รหัสประจำตัวคนไข้.*</span>
                          <input type="text" class="form-control form-control-sm" ref="patcode" name="patcode" v-model="curRecord.PatCode">
                          <button type="button" class="btn btn-info mx-1" @click="autoPatNO()" style="width:80px;" title="กดปุ่ม Auto เพื่อสร้างเลขประจำตัวคนไข้ (Format : Pyymm-nnnnnn เช่น P2301-000001)">Auto</button>
                        </div>
                    </div>
                    <div class="col-4 text-center" hidden>
                        <button type="button" class="btn btn-success " ref="btnReadIDCard" @click="btnReadIDCardClicked()"><i class="fa fa-address-card"></i> อ่านบัตรประชาชน</button>
                    </div>
                </div>
                <div class="row mb-1">
                    <div class="col text-start">
                        <div class="input-group input-group-sm">
                          <span class="input-group-text" style="width:180px;">คำนำหน้า / ชื่อ* / นามสกุล*</span>
                          <input type="text" class="form-control form-control-sm" ref="prefix" name="prefix" v-model="curRecord.PrefixName">
                          <input type="text" class="form-control form-control-sm" ref="patname" name="patname" v-model="curRecord.PatName">
                          <input type="text" class="form-control form-control-sm" ref="patlname" name="patlname" v-model="curRecord.PatLName">
                        </div>
                    </div>
                </div>
                <div class="row mb-1">
                    <div class="col text-start">
                        <div class="input-group input-group-sm">
                          <span class="input-group-text" style="width:180px;"> Prefix / First / last name</span>
                          <input type="text" class="form-control form-control-sm" name="prefix2" v-model="curRecord.PrefixName2">
                          <input type="text" class="form-control form-control-sm" name="patname2" v-model="curRecord.PatName2">
                          <input type="text" class="form-control form-control-sm" name="patlname2" v-model="curRecord.PatLName2">
                        </div>
                    </div>
                </div>
                <div class="row mb-1">
                    <div class="col-6 text-start" title="เลขบัตรประชาชน สำหรับพิมพ์ในใบผลแล็บ">
                        <div class="input-group input-group-sm">
                          <span class="input-group-text" style="width:180px;">หมายเลขบัตรประชาชน</span>
                          <input type="text" class="form-control form-control-sm" ref="IDNo" name="idno" v-model="curRecord.IDNo">
                        </div>
                    </div>
                    <div class="col-6 text-start">
                        <div class="input-group input-group-sm">
                          <span class="input-group-text" style="width:180px;">เลขผู้เสียภาษี</span>
                          <input type="text" class="form-control form-control-sm" name="taxid" v-model="curRecord.TaxID">
                        </div>
                    </div>
                </div>
                <!-- เพศ / วันเกิด -->
                <div class="row mb-3">
                    <div class="col-6 text-start">
                        <!-- <div class="input-group input-group-sm">
                            <span class="input-group-text" style="width:180px;">เพศ</span>
                            <div class="form-check form-check-inline py-1 ms-2">
                              <input class="form-check-input" type="radio" name="sex" id="inlineRadio1" value="1" v-model="curRecord.Sex">
                              <label class="form-check-label" for="inlineRadio1">ชาย</label>
                            </div>
                            <div class="form-check form-check-inline py-1">
                              <input class="form-check-input" type="radio" name="sex" id="inlineRadio2" value="2" v-model="curRecord.Sex">
                              <label class="form-check-label" for="inlineRadio2">หญิง</label>
                            </div>
                        </div> -->
                        <div class="input-group input-group-sm">
                            <div class="input-group-prepend">
                            <span class="input-group-text" style="width:180px;">เพศ* :(1-ชาย,2-หญิง)</span>
                            </div>
                            <input type="number" class="form-control form-control-sm" ref="Sex" name="sex" v-model="curRecord.Sex"
                              min="1" max="2">
                        </div>
                    </div>
                    <!-- วันเกิด -->
                    <div class="col-6 text-start">
                        <!-- <div class="input-group input-group-sm">
                          <span class="input-group-text" style="width:120px;">วันเกิด</span>
                          <v-date-picker :masks="masks" v-model="curRecord.BirthDate">
                            <template v-slot="{ inputValue, inputEvents }">
                              <input name="birthdate"  @change="validBirtday(inputValue)"
                              class="bg-white border px-2 py-1 rounded"
                              :value="inputValue"
                              v-on="inputEvents"
                              />
                            </template>
                          </v-date-picker>
                        </div> -->
                        <div class="input-group input-group-sm" title="ปี ค.ศ. รูปแบบ YYYY-MM-DD">
                          <span class="input-group-text" style="width:120px;">วันเกิด ค.ศ.</span>
                          <v-date-picker v-model="curRecord.BirthDate" :masks="masks"
                            @click="validBirtday(curRecord.BirthDate.toISOString().slice(0, 10))"
                            @change="validBirtday(curRecord.BirthDate.toISOString().slice(0, 10))">
                            <template v-slot="{ inputValue, inputEvents }">
                              <input name="birthdate" ref="BirthDate" @change="validBirtday(inputValue)"
                              class="bg-white border px-2 py-1 rounded" style="width:120px;"
                              :value="inputValue"
                              v-on="inputEvents"
                              />
                            </template>
                          </v-date-picker>
                          <span class="input-group-text ms-2 px-2 py-1" v-if="_agePat>0">อายุ {{_agePat}} ปี</span>
                        </div>
                      <div>
                        <span class="input-group-text px-2 py-1" style="width:120px; font-size:80%;">พ.ศ.{{_birthDayBC}}</span>
                      </div>
                    </div>
                </div>
                <div class="row mb-1">
                    <div class="col text-start">
                        <div class="input-group input-group-sm">
                          <span class="input-group-text" style="width:180px;"> ที่อยู่</span>
                          <input type="text" class="form-control form-control-sm" name="addr1" v-model="curRecord.Addr1">
                        </div>
                    </div>
                </div>
                <div class="row mb-1">
                    <div class="col text-start">
                        <div class="input-group input-group-sm">
                          <span class="input-group-text" style="width:180px;"> ตำบล / อำเภอ / จังหวัด</span>
                          <input type="text" class="form-control form-control-sm" name="tambon" v-model="curRecord.Tambon">
                          <input type="text" class="form-control form-control-sm" name="amphor" v-model="curRecord.Amphor">
                          <input type="text" class="form-control form-control-sm" name="province" v-model="curRecord.Province">
                        </div>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-6 text-start">
                        <div class="input-group input-group-sm">
                          <span class="input-group-text" style="width:180px;"> รหัสไปรษณีย์</span>
                          <input type="text" class="form-control form-control-sm" name="postcode" v-model="curRecord.PostCode">
                        </div>
                    </div>
                </div>

                <div class="row mb-1">
                    <div class="col text-start">
                        <div class="input-group input-group-sm">
                          <span class="input-group-text" style="width:180px;">โทรศัพท์#1 / โทรศัพท์#2 </span>
                          <input type="text" class="form-control form-control-sm" name="tel1" v-model="curRecord.Tel1">
                          <input type="text" class="form-control form-control-sm" name="tel2" v-model="curRecord.Tel2">
                        </div>
                    </div>
                </div>
                <div class="row mb-1">
                    <div class="col text-start">
                        <div class="input-group input-group-sm">
                          <span class="input-group-text" style="width:180px;">Email#1 / Email#2 </span>
                          <input type="text" class="form-control form-control-sm" name="email1" v-model="curRecord.Email1">
                          <input type="text" class="form-control form-control-sm" name="email2" v-model="curRecord.Email2">
                        </div>
                    </div>
                </div>

                <div class="row mt-2 mb-2">
                  <div class="col-6 text-start" >
                    <div class="form-check form-check-inline mx-3 pt-2" title="คลิกเลือกถ้าเป็นคนต่างชาติ ">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" ref="Foreigner" name="foreigner"
                        :checked="curRecord.Foreigner==1"  value="1" v-model="curRecord.Foreigner">
                      <label class="form-check-label" for="inlineCheckbox1"> เป็นคนต่างชาติ </label>
                    </div>
                  </div>
                </div>
                <!-- เชื้อชาติ / สัญชาติ -->
                <div class="row mb-1">
                  <div class="col-6 text-start" >
                    <div class="input-group input-group-sm" title="เป็นคนเชื้อชาติอะไร">
                      <span class="input-group-text" style="width:180px;">เชื้อชาติ</span>
                      <input type="text" class="form-control form-control-sm" ref="Race" name="race" v-model="curRecord.Race">
                    </div>
                  </div>
                  <div class="col-6 text-start" >
                    <div class="input-group input-group-sm" title="สัญชาติ">
                      <span class="input-group-text" style="width:120px;">สัญชาติ</span>
                      <input type="text" class="form-control form-control-sm" name="nationality" v-model="curRecord.Nationality">
                    </div>
                  </div>
                </div>
                <!-- พาสพอร์ตนัมเบอร์ / ประเทศที่มา -->
                <div class="row mt-2 mb-2">
                  <div class="col-6 text-start" >
                    <div class="input-group input-group-sm" title="หมายเลขหนังสือเดินทาง">
                      <span class="input-group-text" style="width:180px;">หมายเลขหนังสือเดินทาง</span>
                      <input type="text" class="form-control form-control-sm" ref="PassportNo" name="passportno" v-model="curRecord.PassportNo">
                    </div>
                  </div>
                  <div class="col-6 text-start" >
                    <div class="input-group input-group-sm" title="ประเทศ (ที่มา)">
                      <span class="input-group-text" style="width:120px;">ประเทศ</span>
                      <input type="text" class="form-control form-control-sm" name="country" v-model="curRecord.Country">
                    </div>
                  </div>
                </div>
                <!-- โรคประจำตัว (ถ้ามี) -->
                <div class="row mb-1">
                  <div class="col-12 text-start p-2" >
                    <div class="input-group input-group-sm" title="โรคประจำตัว (congenital disease)">
                      <span class="input-group-text text-danger" style="width:180px;">โรคประจำตัว (ถ้ามี)</span>
                      <input type="text" class="form-control form-control-sm" ref="CongDisease" name="congdisease" v-model="curRecord.CongDisease">
                    </div>
                  </div>
                </div>
                <!-- ยาที่แพ้ (ถ้ามี) -->
                <div class="row mb-1">
                  <div class="col text-start" >
                    <div class="input-group input-group-sm" title="ระบุรายชื่อยาที่แพ้ (Drug Allergy)">
                      <span class="input-group-text text-danger" style="width:180px;">ยาที่แพ้ (ถ้ามี)</span>
                      <input type="text" class="form-control form-control-sm" ref="DrugAllergy" name="drugallergy" v-model="curRecord.DrugAllergy">
                    </div>
                  </div>
                </div>
                <br>
            </form>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" ref="btnCloseModal" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" @click="saveNewPatientData()">Save changes</button>
          </div>
        </div>
      </div>
    </div>

    <!-- ========================================================= -->
    <!-- HEADER -->
    <!-- Modal ลบ Specimen ของ ใบสั่งตรวจ -->
    <div id="removeSpecimenHdModal" class="modal" tabindex="-1">
        <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title">Remove Specimen | ใบสั่งตรวจ</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="container">
                <div v-if="curRecordHd.Specimen.length>0">
                  <ul class="list-group">
                  <li v-for="item in curRecordHd.Specimen.split(',')" :key="item" class="list-group-item d-flex justify-content-between align-items-center list-group-item-warning">
                      {{item}}
                      <span class="btn badge bg-danger rounded-pill" title="ลบออก" @click="removeSpecimenHd(curRecordHd.Specimen, item)">Remove</span>
                  </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
        </div>
    </div>
    <!-- Modal เพิ่ม Specimen ของ ใบสั่งตรวจ -->
    <div id="addSpecimenHdModal" class="modal" tabindex="-1">
        <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title">Add Specimen | ใบสั่งตรวจ</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="container">
                <ul class="list-group">
                <li v-for="item in dataSpecimenlists" :key="item" class="list-group-item d-flex justify-content-between align-items-center list-group-item-warning">
                    {{item.Name}}
                    <span class="btn badge bg-primary rounded-pill" title="เพิ่ม"  @click="addSpecimenHd(item.Name)">Add</span>
                </li>
                </ul>
              </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
        </div>
    </div>
    <!-- ========================================================= -->
    <!-- Modal ลบ Specimen ของชุดตรวจรายการปัจจุบัน -->
    <div id="removeSpecimenModal" class="modal" tabindex="-1">
        <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title">Remove Specimen | ลบ</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="container">
                <div v-if="dataDtllists.length>0">
                  <ul class="list-group">
                  <li v-for="item in dataDtllists[curRowIndexDtl].Specimen.split(',')" :key="item" class="list-group-item d-flex justify-content-between align-items-center list-group-item-warning">
                      {{item}}
                      <span class="btn badge bg-danger rounded-pill" title="ลบออก" @click="removeSpecimen(dataDtllists[curRowIndexDtl].Specimen, item)">Remove</span>
                  </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
        </div>
    </div>
    <!-- Modal เพิ่ม Specimen ของชุดตรวจรายการปัจจุบัน -->
    <div id="addSpecimenModal" class="modal" tabindex="-1">
        <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title">Add Specimen | เพิ่ม</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="container">
                <ul class="list-group">
                <li v-for="item in dataSpecimenlists" :key="item" class="list-group-item d-flex justify-content-between align-items-center list-group-item-warning">
                    {{item.Name}}
                    <span class="btn badge bg-primary rounded-pill" title="เพิ่ม"  @click="addSpecimen(item.Name)">Add</span>
                </li>
                </ul>
              </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
        </div>
    </div>
    <!-- ========================================================= -->
    <!-- Modal เพิ่ม Remark -->
    <div id="addRemarkModal" class="modal" tabindex="-1">
        <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title">Add Remark | เพิ่ม</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="container-fluid p-2 border border-2 border-secondary shadow" style="height: 400px;">
                <div class="mh-100 vh-100 overflow-auto ">
                  <ul class="list-group">
                  <li v-for="item in dataRemarklists" :key="item" class="list-group-item d-flex justify-content-between align-items-center list-group-item-warning">
                      <span class="text-start">{{item.Remark}}</span>
                      <span class="btn badge bg-primary rounded-pill" title="เพิ่ม"  @click="addRemark(item.Remark)">Add</span>
                  </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
// import axios from 'axios'
import myfuncs from '../myjs/myfuncs.js'
import { MyApiClient } from '../myjs/my-api-client.js'
// // ****** Bootstrap and jQuery libraries ******
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// // ****** Datatable Modules *******
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  name: 'LabCreate2New',
  data () {
    return {
      masks: {
        input: 'YYYY-MM-DD'
      },
      arrDocStatus: ['New', 'Lab', 'Resulted', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต'],
      lastRONo: null,
      lastPatNo: null,
      // รายชื่อคนไข้เดิมที่ค้นหาจากคำค้นหา ใน Modal
      findTextPatient: '',
      dataPatientFindlists: [],

      // ห้องที่เลือกใน modal
      rdRoomTypeID: 0,
      dataTS_chkboxlist: [], // รายการชุดตรวจเฉพาะห้องที่เลือก
      TS_selectedlist: [], // คลิกจาก checkbox เลือกหลายๆ เทสใส่คนไข้ <<<
      // เลือกชุดตรวจจากประวัติเดิม
      condHistPatID: 0, // ID ของคนไข้(curRecordHd.PatID) สำหรับเช็คว่าเปลี่ยนแปลง watch จะไปดึงประวัติ ROHd
      condHistROID: 0, // ID ของใบสั่งตรวจเดิม(เมื่อคลิกปุ่ม เลือกจากประวัติเดิม)
      dataHistPatROlists: [], // ใบสั่งตรวจเดิม(วันที่และเลขที่) ของคนไข้ที่ระบุ
      dataHistPatRODtllists: [], // ชุดเทสตรวจเดิมจากใบสั่งที่เลือก
      // Specimen ของชุดตรวจที่คลิกเลือก เป็น string with comma
      curRowIndexDtl: 0,
      // เก็บรายการชุดตรวจที่เพิ่มเข้ามา : RO-Detail
      dataDtllists: [],
      // เก็บรายการแพคเกจชุดตรวจที่เพิ่มเข้ามา : RO-PropackDetail
      dataDtllistsPropack: [],
      // Master
      curRecordHd: {
        BranchID: this.globalBranchID,
        ROID: 0,
        RONo: '',
        DocDate: new Date(),
        DocTime: this.getTimeNow(),
        PatID: 0,
        PatName: '',
        PatLName: '',
        Weight: '',
        Height: '',
        Pulse: '',
        BodyTemp: '',
        BP_1: '',
        BP_2: '',
        SpO2: '',
        Specimen: '',
        ReqClinicID: 0,
        UnitPriceNo: 1,
        HNNo: '',
        OfficerID1: 0,
        OfficerName1: '',
        Remark: '',
        TotalAmt: 0.0,
        DiscRate: 0.0,
        DiscAmt: 0.0,
        TotalAmt_BfVat: 0.0,
        VatRate: 0.0,
        VatAmt: 0.0,
        NetAmt: 0.0,
        PayType: 0,
        EarnestAmt: 0.0,
        Status: 0,
        Paid: 0 // ถ้าชำระเงินแล้ว จะแก้ไขรายการตรวจ,ส่วนลดและ %vat ไม่ได้
      },
      action: 'new',

      // Modal New Patient
      curRecord: {
        PatCode: '',
        PrefixName: '',
        PatName: '',
        PatLName: '',
        IDNo: '',
        Sex: 1
      }
    }
  },
  props: ['rowEdit', 'dataRoomtypelists', 'dataTestSuitlists', 'dataPropacklists', 'dataCliniclists', 'dataOfficerlists', 'dataBranchlists', 'dataSpecimenlists', 'dataRemarklists'],
  mounted () {
    this.assignDataMaster()
    this.getDataDetail()
    this.getDataDetailPropack()
    this.$nextTick(() => {
      $('#myAddTestsuitTable').DataTable()
    })

    this.dataTS_chkboxlist = this.dataTestSuitlists // รายการ TS สำหรับแสดง checkbox
  },
  computed: {
    // a computed getter
    _agePat: function () {
      if (this.curRecord.BirthDate == null) { return 0 }
      return myfuncs.calculateAge(new Date(this.curRecord.BirthDate))
    },
    _birthDayBC: function () {
      if (typeof this.curRecord.BirthDate === 'undefined' || this.curRecord.BirthDate === null) {
        return null
      }
      var newDateAD
      if (myfuncs.isBEBirthDate(new Date(this.curRecord.BirthDate))) {
        newDateAD = myfuncs.DateBE2AD(this.curRecord.BirthDate)
      } else {
        newDateAD = this.curRecord.BirthDate
      }
      return new Date(newDateAD).toLocaleString('th-TH', { year: 'numeric', month: '2-digit', day: '2-digit' })
    }
  },
  components: {

  },
  watch: {
    condHistPatID: 'getHistROHdOfPat', // มีการระบุคนไข้แล้วให้ไปดึงประวัติ ROHd
    condHistROID: 'getHistRODtlOfPat' // เลือกใบสั่งตรวจเดิมแล้ว ดึงชุดเทสตรวจเดิมมาแสดง
  },
  methods: {
    autoPatNO () {
      let NewPatNo = ''
      // ====================================
      // 1. call fnc. get_prefix : PYYMM
      // 2. call MyApiClient.get
      // 3. call fnc. gen_newpatno
      // ====================================
      // 1.
      let prefix = ''
      prefix = myfuncs.genPatNo_getPrefix(this.globalCorpID)
      // 2.
      MyApiClient.get('getdata/getlast_patno_prefix.php?C1=' + this.globalCorpID + '&prefix=' + prefix)
        .then((resp) => {
          let lastPatNo = ''
          lastPatNo = resp.data.response[0].LastPatNo
          // 3.
          NewPatNo = myfuncs.genPatNo_New(prefix, lastPatNo)
          this.curRecord.PatCode = NewPatNo
          // console.log(NewPatNo)
        })
        .catch((err) => {
          console.log(err.response)
          Swal.fire({ icon: 'error', text: 'ไม่สามารถดึงเลขที่เอกสารล่าสุดได้' })
        })
    },
    // validBirtday (datestr) {
    //   // ถ้าไม่ใช่ YYYY-MM-DD ให้แปลงเป็น YYYY-MM-DD
    //   if (!this.isValidDate(datestr)) {
    //     this.curRecord.BirthDate = this.convertDMY2YMD(datestr)
    //   }
    // },
    validBirtday (datestr) {
      var newDateAD, newDateADstr
      // 1. Format Date ไม่เป็น YYYY-MM-DD
      if (!this.isValidDate(datestr)) {
        // 2. แปลงเป็น YYYY-MM-DD และ Check ว่าเป็น พ.ศ. หรือไม่?
        if (myfuncs.isBEBirthDate(this.convertDMY2YMD(datestr))) {
          // 3. แปลงวันเกิด พ.ศ. เป็น ค.ศ.
          newDateAD = myfuncs.DateBE2AD(this.convertDMY2YMD(datestr))
          newDateADstr = newDateAD.toISOString().slice(0, 10)
        } else {
          // 4. เป็นวันเกิด ค.ศ. อยู่แล้ว (แต่ป้อนมาเป็น DD-MM-YYYY)
          newDateAD = this.convertDMY2YMD(datestr)
          newDateADstr = newDateAD.toISOString().slice(0, 10)
        }
      } else { // ป้อนมาเป็น YYYY-MM-DD
        // Check ว่าเป็น พ.ศ. หรือไม่?
        if (myfuncs.isBEBirthDate(new Date(datestr))) {
          // 3. แปลงวันเกิด พ.ศ. เป็น ค.ศ.
          newDateAD = myfuncs.DateBE2AD(new Date(datestr))
          newDateADstr = newDateAD.toISOString().slice(0, 10)
        } else {
          // 4. เป็นวันเกิด YYYY-MM-DD และเป็น ค.ศ. อยู่แล้ว
          newDateAD = new Date(datestr)
          newDateADstr = newDateAD.toISOString().slice(0, 10)
        }
      }
      this.curRecord.BirthDate = new Date(newDateADstr)
    },
    // =========================
    // ใช้ฟังก์ชั่นจากไฟล์ร่วม .js
    isValidDate (datestring) {
      return myfuncs.isValidDate(datestring)
    },
    convertDMY2YMD (datestring) {
      return myfuncs.convertDMY2YMD(datestring)
    },
    // =========================
    getClinicUnitPriceNo (evt) {
      //  ID คลินิกที่เลือก
      var idClinic = evt.target.value
      // find Obj in Array by 'ReqClinicID' key : return obj row
      const result = this.dataCliniclists.find(({ ReqClinicID }) => ReqClinicID === idClinic)
      this.curRecordHd.UnitPriceNo = result.UnitPriceNo // this.unitPriceNo = result.UnitPriceNo

      // Recalculate คำนวณ จำนวนเงินท้ายบิล จาก items ชุดตรวจ
      this.calculateAmountMaster()
    },
    // ดึง DETAIL : รายการเทสในใบสั่งตรวจ
    getDataDetail () {
      var ROID = this.rowEdit.ROID
      MyApiClient.get('getdata/reqdtl_where_id.php?ID=' + ROID)
        .then((resp) => {
          this.dataDtllists = resp.data.response
          if (this.dataDtllists == null) {
            this.dataDtllists = []
            Swal.fire({ icon: 'info', text: 'ไม่มีข้อมูล', showConfirmButton: false, timer: 1000 })
          }
          // คำนวณจำนวนเงินใหม่หลังเปิดหน้าจอแก้ไข ป้องกันกรณีราคาขาย 1-5 ในมาสเตอร์เปลี่ยนแปลง
          this.calculateAmountMaster()
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    // ดึง DETAIL PROPACK : รายการแพคเกจในใบสั่งตรวจ
    getDataDetailPropack () {
      var ROID = this.rowEdit.ROID
      MyApiClient.get('getdata/reqdtlpropack_where_id.php?ID=' + ROID)
        .then((resp) => {
          this.dataDtllistsPropack = resp.data.response
          if (this.dataDtllistsPropack == null) {
            this.dataDtllistsPropack = []
            Swal.fire({ icon: 'info', text: 'ไม่มีข้อมูล', showConfirmButton: false, timer: 1000 })
          }
          // คำนวณจำนวนเงินใหม่หลังเปิดหน้าจอแก้ไข ป้องกันกรณีราคาขาย 1-5 ในมาสเตอร์เปลี่ยนแปลง
          this.calculateAmountMaster()
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getDataMaster () {
      // ใช้การ assign (function assignDataMaster) ค่าให้แทนการดึงจาก API
    },
    assignDataMaster () {
      this.curRecordHd.BranchID = this.rowEdit.BranchID
      this.curRecordHd.ROID = this.rowEdit.ROID
      this.curRecordHd.RONo = this.rowEdit.RONo
      this.curRecordHd.DocDate = this.rowEdit.DocDate
      this.curRecordHd.DocTime = this.rowEdit.DocTime
      this.curRecordHd.PatID = this.rowEdit.PatID
      this.curRecordHd.PatName = this.rowEdit.PatName
      this.curRecordHd.PatLName = this.rowEdit.PatLName
      this.curRecordHd.Weight = this.rowEdit.Weight
      this.curRecordHd.Height = this.rowEdit.Height
      this.curRecordHd.Pulse = this.rowEdit.Pulse
      this.curRecordHd.BodyTemp = this.rowEdit.BodyTemp
      this.curRecordHd.BP_1 = this.rowEdit.BP_1
      this.curRecordHd.BP_2 = this.rowEdit.BP_2
      this.curRecordHd.SpO2 = this.rowEdit.SpO2
      this.curRecordHd.Specimen = this.rowEdit.Specimen
      this.curRecordHd.ReqClinicID = this.rowEdit.ReqClinicID
      this.curRecordHd.UnitPriceNo = this.rowEdit.UnitPriceNo
      this.curRecordHd.HNNo = this.rowEdit.HNNo
      this.curRecordHd.OfficerID1 = this.rowEdit.OfficerID1
      // this.curRecordHd.OfficerName1 = this.rowEdit.OfficerName1
      this.curRecordHd.Remark = this.rowEdit.Remark
      this.curRecordHd.TotalAmt = this.rowEdit.TotalAmt
      this.curRecordHd.DiscRate = this.rowEdit.DiscRate
      this.curRecordHd.DiscAmt = this.rowEdit.DiscAmt
      this.curRecordHd.TotalAmt_BfVat = this.rowEdit.TotalAmt_BfVat
      this.curRecordHd.VatRate = this.rowEdit.VatRate
      this.curRecordHd.VatAmt = this.rowEdit.VatAmt
      this.curRecordHd.NetAmt = this.rowEdit.NetAmt
      this.curRecordHd.PayType = this.rowEdit.PayType
      this.curRecordHd.EarnestAmt = this.rowEdit.EarnestAmt
      this.curRecordHd.Status = this.rowEdit.Status
      this.curRecordHd.Paid = this.rowEdit.Paid

      // เงื่อนไขในการแสดงหรือซ่อน "ปุ่มเลือกชุดเทสตรวจจากประวัติเดิม"
      this.condHistPatID = this.curRecordHd.PatID
    },

    addRemark (str) {
      var taRemark = this.$refs.taRemark
      var curPos = taRemark.selectionStart

      this.curRecordHd.Remark =
        this.curRecordHd.Remark.slice(0, curPos) +
        str +
        this.curRecordHd.Remark.slice(curPos)
      // this.curRecordHd.Remark = this.curRecordHd.Remark + str
    },
    // ============ Begin : specimen Header ============= //
    removeSpecimenHd (strSrc, strRem) {
      this.curRecordHd.Specimen = this.strCommaRemoveValue(strSrc, strRem)
    },
    addSpecimenHd (str) {
      let comma = ''
      if (this.curRecordHd.Specimen.length > 0) {
        comma = ', '
      }
      this.curRecordHd.Specimen = this.curRecordHd.Specimen + comma + str
    },
    btnRemoveSpecimenHdClicked () {
      // DO NOTTHING
    },
    btnAddSpecimenHdClicked () {
      // DO NOTTHING
    },
    clearSpecimenHdAll () {
      this.curRecordHd.Specimen = ''
    },
    // ============ End : specimen Header ============= //

    // ============ Begin : specimen รายการสั่งตรวจ ============= //
    removeSpecimen (strSrc, strRem) {
      this.dataDtllists[this.curRowIndexDtl].Specimen = this.strCommaRemoveValue(strSrc, strRem)
    },
    addSpecimen (str) {
      let comma = ''
      if (this.dataDtllists[this.curRowIndexDtl].Specimen.length > 0) {
        comma = ', '
      }
      this.dataDtllists[this.curRowIndexDtl].Specimen = this.dataDtllists[this.curRowIndexDtl].Specimen + comma + str
    },
    strCommaRemoveValue (list, value) {
      list = list.split(',')
      list.splice(list.indexOf(value), 1)
      return list.join(',')
    },
    btnRemoveSpecimenClicked (index) {
      this.curRowIndexDtl = index
    },
    btnAddSpecimenClicked (index) {
      this.curRowIndexDtl = index
    },
    clearSpecimenAll (index) {
      this.dataDtllists[index].Specimen = ''
    },
    // ============ End :  specimen รายการสั่งตรวจ ============= //

    btnAddPatientClick () {
      // $('#fmPatient').trigger('reset')
      this.$refs.fmPatient.reset()
      this.$refs.CorpIDpat.value = this.globalCorpID // reset บรรทัดบนทำให้ค่าหาย ต้องใส่ใหม่
      this.$refs.patcode.focus()

      this.curRecord = {
        PatCode: '',
        PrefixName: '',
        PatName: '',
        PatLName: '',
        IDNo: '',
        Sex: 1
      }
    },
    checkFieldsPatientBeforeSave () {
      if ((this.$refs.patcode.value === '')) {
        this.$refs.patcode.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "รหัสประจำตัวคนไข้" ', showConfirmButton: false, timer: 1500 })
        return false
      }
      if ((this.$refs.prefix.value === '')) {
        this.$refs.prefix.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "คำนำหน้าชื่อคนไข้" ', showConfirmButton: false, timer: 1500 })
        return false
      }
      if ((this.$refs.patname.value === '')) {
        this.$refs.patname.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "ชื่อคนไข้" ', showConfirmButton: false, timer: 1500 })
        return false
      }
      if ((this.$refs.patlname.value === '')) {
        this.$refs.patlname.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "นามสกุลคนไข้" ', showConfirmButton: false, timer: 1500 })
        return false
      }
      if ((this.$refs.IDNo.value === '')) {
        if (!(this.alertConfirmYesNo('หมายเลขประจำตัวบัตรประชาชนไม่มีข้อมูล!'))) {
          this.$refs.IDNo.focus()
          Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "หมายเลขบัตรประชาชน" ', showConfirmButton: false, timer: 1500 })
          return false
        }
      }
      if ((this.curRecord.Sex === '' || this.curRecord.Sex < 1 || this.curRecord.Sex > 2)) {
        this.$refs.Sex.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "เพศคนไข้" ', showConfirmButton: false, timer: 1500 })
        return false
      }
      return true
    },
    saveNewPatientData () {
      var self = this
      // แปลงข้อมูลจากฟอร์ม
      if (this.checkFieldsPatientBeforeSave()) {
        var x = $('#fmPatient').serializeArray()
        var formData = {}
        $.each(x, function (i, field) {
          $.extend(formData, { [field.name]: field.value })
        })
        // Insert/Update by call API
        $.ajax({
          type: 'POST',
          url: this.http_baseurl + 'setdata/insert_patient.php',
          data: { request: JSON.stringify(formData) }
        })
          .done(function (resp) {
            var elem = self.$refs.btnCloseModal
            elem.click()
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'บันทึกข้อมูลเสร็จเรียบร้อย',
              showConfirmButton: false,
              timer: 1500
            }).then(function (result) {
              // หลังจากเพิ่มรายชื่อคนไข้ใหม่แล้ว ให้ถือว่าเลือกโดยอัตโนมัติ
              self.selectPatientAfterInsert(formData)
            })
          })
          .fail(function (resp) {
            // alert('Not Saved')
            Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
          })
      }
    },
    selectPatientAfterInsert (row) {
      MyApiClient.get('getdata/patient_code.php?C1=' + this.globalCorpID + '&key=' + row.patcode)
        .then((resp) => {
          // result => Array of Record
          this.curRecordHd.PatID = resp.data.response[0].PatID
          this.curRecordHd.PatName = resp.data.response[0].PatName
          this.curRecordHd.PatLName = resp.data.response[0].PatLName
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    openAddPatModal () {
      // data-bs-target="#addPatientModal"
      document.getElementById('btnNewPat').click()
    },
    calculateAmountMaster () {
      const unitPriceNo = this.curRecordHd.UnitPriceNo
      let totalAmt = 0
      // ตารางรายการสั่งตรวจ - ชุดตรวจ ใช้ราคาขายตามที่กำหนดไว้ในคลินิกที่เลือก
      for (let i = 0; i < this.dataDtllists.length; i++) {
        if (unitPriceNo === 1 || unitPriceNo === '1') {
          totalAmt = totalAmt + parseFloat(this.dataDtllists[i].UnitPrice)
        } else if (unitPriceNo === 2 || unitPriceNo === '2') {
          totalAmt = totalAmt + parseFloat(this.dataDtllists[i].UnitPrice2)
        } else if (unitPriceNo === 3 || unitPriceNo === '3') {
          totalAmt = totalAmt + parseFloat(this.dataDtllists[i].UnitPrice3)
        } else if (unitPriceNo === 4 || unitPriceNo === '4') {
          totalAmt = totalAmt + parseFloat(this.dataDtllists[i].UnitPrice4)
        } else if (unitPriceNo === 5 || unitPriceNo === '5') {
          totalAmt = totalAmt + parseFloat(this.dataDtllists[i].UnitPrice5)
        }
      }
      // ตารางรายการสั่งตรวจ - แพคเกจ
      for (let i = 0; i < this.dataDtllistsPropack.length; i++) {
        totalAmt = totalAmt + parseFloat(this.dataDtllistsPropack[i].UnitPrice)
      }
      // รวมเป็นเงิน
      this.curRecordHd.TotalAmt = totalAmt
      // เปอร์เซ็นต์ส่วนลด, ส่วนลดเป็นเงิน, จำนวนเงินหลังหักส่วนลด
      if (Number(this.curRecordHd.DiscRate) === Number(0)) {
        this.curRecordHd.TotalAmt_BfVat = this.curRecordHd.TotalAmt - this.curRecordHd.DiscAmt
      } else {
        this.curRecordHd.DiscAmt = (this.curRecordHd.TotalAmt * this.curRecordHd.DiscRate) / 100
        this.curRecordHd.TotalAmt_BfVat = this.curRecordHd.TotalAmt - this.curRecordHd.DiscAmt
      }
      // อัตราภาษีมูลค่าเพิ่ม, ภาษีมูลค่าเพิ่มเป็นเงิน, จำนวนเงินสุทธิ
      this.curRecordHd.VatAmt = (this.curRecordHd.TotalAmt_BfVat * this.curRecordHd.VatRate) / 100
      this.curRecordHd.NetAmt = this.curRecordHd.TotalAmt_BfVat + this.curRecordHd.VatAmt
    },
    getToday () {
      return new Date().toJSON().slice(0, 10).replace(/-/g, '/')
    },
    getTimeNow () {
      const today = new Date()
      const h = today.getHours()
      let m = today.getMinutes()
      let s = today.getSeconds()
      if (m < 10) { m = '0' + m }
      if (s < 10) { s = '0' + s }

      return (h + ':' + m + ':' + s)
    },
    saveDataMasterDetail () {
      var self = this
      if (this.checkFieldsHeaderBeforeSave()) {
        // แปลงข้อมูลจากฟอร์ม
        var x = $('#fmRO').serializeArray()
        var formData = {}
        $.each(x, function (i, field) {
          $.extend(formData, { [field.name]: field.value })
        })
        // Insert/Update by call API
        $.ajax({
          type: 'POST',
          url: this.http_baseurl + 'setdata/update_ro_masterdetail.php',
          data: {
            request: JSON.stringify(this.curRecordHd),
            requestDtl: JSON.stringify(this.dataDtllists),
            requestDtl2: JSON.stringify(this.dataDtllistsPropack),
            request2: JSON.stringify(formData)
          }
        })
          .done(function (resp) {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'บันทึกข้อมูลเสร็จเรียบร้อย',
              showConfirmButton: false,
              timer: 1500
            }).then(function (result) {
              self.backPageAfterSave()
            })
          })
          .fail(function (resp) {
            console.log(resp)
            Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
          })
      }
    },
    checkFieldsHeaderBeforeSave () {
      if (!(this.curRecordHd.BranchID > 0)) {
        this.$refs.BranchID.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "สาขา" ที่ป้อนเอกสาร', showConfirmButton: false, timer: 1500 })
        return false
      }
      if ((this.curRecordHd.RONo === '')) {
        this.$refs.RONo.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "เลขที่เอกสาร" ', showConfirmButton: false, timer: 1500 })
        return false
      }
      if ((this.curRecordHd.DocDate === null)) {
        this.$refs.DocDate.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "วันที่เอกสาร" ของเอกสาร', showConfirmButton: false, timer: 1500 })
        return false
      }
      if (!(this.curRecordHd.PatID > 0)) {
        this.$refs.PatID.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "ชื่อ-นามสกุล" คนไข้', showConfirmButton: false, timer: 1500 })
        return false
      }
      if (!(this.curRecordHd.OfficerID1 > 0)) {
        this.$refs.OfficerID1.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "พนักงาน" ที่ป้อนเอกสาร', showConfirmButton: false, timer: 1500 })
        return false
      }
      return true
    },
    selectPatient (row) {
      this.curRecordHd.PatID = row.PatID
      this.curRecordHd.PatName = row.PatName
      this.curRecordHd.PatLName = row.PatLName
    },
    findPatients () {
      if (this.findTextPatient === '') {
        Swal.fire({ icon: 'error', text: 'กรุณาป้อนคำค้นหาอย่างน้อย 1 ตัวอักษร' })
        return
      }
      MyApiClient.get('getdata/patient_like.php?C1=' + this.globalCorpID + '&findText=' + this.findTextPatient)
        .then((resp) => {
          // console.log(resp.data.response)
          this.dataPatientFindlists = resp.data.response
          // this.$nextTick(() => {
          //   $('#myFindPatientTable').DataTable()
          // })
          $('#myFindPatientTable').DataTable().destroy()
          setTimeout(function () { $('#myFindPatientTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    delDtlTable (indexRow) {
      this.dataDtllists.splice(indexRow, 1)
      this.calculateAmountMaster()
    },
    delDtlTablePropack (indexRow) {
      this.dataDtllistsPropack.splice(indexRow, 1)
      this.calculateAmountMaster()
    },
    // เพิ่มรายการชุดตรวจที่เลือกจาก checkbox
    addDtlTable_from_TS_selectedlist (rows) {
      rows.forEach((row) => {
        var curRow = Object.assign({}, row)
        // แทรก "NewPage" property ใหม่ ให้กับ object รายการสั่งตรวจ
        curRow.NewPage = 0
        this.dataDtllists.push(curRow)
      })
      this.calculateAmountMaster()
    },
    addDtlTable (row) {
      var curRow = Object.assign({}, row)
      this.dataDtllists.push(curRow)
      this.calculateAmountMaster()
    },
    addDtlTablePropack (row) {
      var curRow = Object.assign({}, row)
      // แทรก "NewPage" property ใหม่ ให้กับ object แพคเกจสั่งตรวจ
      curRow.NewPage = 0
      this.dataDtllistsPropack.push(curRow)
      this.calculateAmountMaster()
    },
    backPage () {
      this.$emit('onBackPageEvent')
    },
    backPageAfterSave () {
      this.$emit('onBackPageAfterSaveEvent')
    },
    // Modal "addTestsuit_CheckboxModal" : 03.09.2566
    roomType_Changed (row) {
      if (row === null) {
        this.dataTS_chkboxlist = this.dataTestSuitlists
      } else {
        this.dataTS_chkboxlist = row.TS
      }
    },
    addTestsuit_Checkbox_Clicked () {
      this.TS_selectedlist = [] // Reset all Checkbox to uncheck
    },
    // ============================================= //
    // กดปุ่ม "เลือกจากประวัติเดิม"
    // Modal "addTestsuit_HistoryModal" : 11.04.2567
    addTestsuit_History_Clicked () {
      this.dataHistPatRODtllists = []
    },
    getHistROHdOfPat () {
      // ดึง header ใบสั่งตรวจเดิมของ PatID มา 10 ครั้งล่าสุด
      MyApiClient.get('getdata/rohd_where_patid.php?C1=' + this.globalCorpID + '&ID=' + this.curRecordHd.PatID)
        .then((resp) => {
          // result => Array of Record
          // console.log(resp.data.response)
          this.dataHistPatROlists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getHistRODtlOfPat () {
      // ดึง detail ของใบสั่งตรวจเดิมที่คลิกเลือก : ชุดเทสตรวจเดิมที่เคยสั่งของใบนั้นๆ
      MyApiClient.get('getdata/rodtl_where_patid_roid.php?C1=' + this.globalCorpID + '&ID=' + this.curRecordHd.PatID + '&ROID=' + this.condHistROID)
        .then((resp) => {
          // result => Array of Record
          // console.log(resp.data.response)
          this.dataHistPatRODtllists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    myHistPatROTableChanged (event, row) {
      var curRow = Object.assign({}, row)
      this.curRecord_HistPatRO = curRow
      this.condHistROID = curRow.ROID // มีการคลิกเลือกใบสั่งตรวจเดิมจากตาราง -> ดึงชุดตรวจที่เคยสั่งมาแสดง
      // ================================ //
      // แถบสี row ที่คลิก
      this.getSelectedRow_HistPatRO(event, row)
    },
    // แสดงแถบสีว่า เลือก row นี้
    getSelectedRow_HistPatRO (event, row) {
      // console.log('row Index :')
      // console.log(event.target.parentNode.rowIndex)
      this.index = event.target.parentNode.rowIndex
      var table = document.getElementById('myHistPatROTable') // **** ID ตาราง *** //
      for (var i = 1; i < table.rows.length; i++) {
        table.rows[i].style.backgroundColor = 'white'
        table.rows[i].style.color = 'black'
      }
      table.rows[this.index].style.backgroundColor = 'MediumBlue'
      table.rows[this.index].style.color = 'white'
    }
  }
}
</script>

<style>

</style>
